import { mount } from 'svelte'

import createResearchStores from '../stores/createResearchStores'


import AnimatedValue from '../../components/projects/facts-and-figures/core/dataviz/AnimatedValue.svelte'
import DecorativeDonut from '../../components/projects/facts-and-figures/composite/DecorativeDonut.svelte'
import DecorativeHorizontalBars from '../../components/projects/facts-and-figures/composite/DecorativeHorizontalBars.svelte'
import GenericDonut from '../../components/projects/facts-and-figures/highcharts/GenericDonut.svelte'
import LabelValueParagraph from '../../components/projects/facts-and-figures/core/visual/LabelValueParagraph.svelte'
import OpenBottomDonut from '../../components/projects/facts-and-figures/composite/OpenBottomDonut.svelte'
import PressGaneyDounut from '../../components/projects/facts-and-figures/composite/PressGaneyDonut.svelte'
import SoloBarChart from '../../components/projects/facts-and-figures/composite/SoloBarChart.svelte'
import StandardDonut from '../../components/projects/facts-and-figures/composite/StandardDonut.svelte'
import ThreeColList from '../../components/projects/facts-and-figures/core/ThreeColList.svelte'
import JsonDebug from '../../components/utilities/JsonDebug.svelte'

/**
 * Fetch data for Faculty; Mount components with data
 */
export default function () {
  const [
    data,
    loading,
    error,
    
    blueridgeDerived,
    pharmaDerived,
    holdingsDerived,
    averageawardDerived,
    labsDerived,
    restotalindustryfundingDerived,
    coresDerived
  ] = createResearchStores()

  if(document.getElementById('blueridge')) {
    mount(LabelValueParagraph, {
      target: document.getElementById('blueridge'),
      props: {
        store: blueridgeDerived
      }
    })
  }

  if(document.getElementById('pharma')) {
    mount(LabelValueParagraph, {
      target: document.getElementById('pharma'),
      props: {
        store: pharmaDerived
      }
    })
  }

  if(document.getElementById('holdings')) {
    mount(LabelValueParagraph, {
      target: document.getElementById('holdings'),
      props: {
        store: holdingsDerived
      }
    })
  }

  if(document.getElementById('avg-award')) {
    mount(LabelValueParagraph, {
      target: document.getElementById('avg-award'),
      props: {
        store: averageawardDerived
      }
    })
  }

  if(document.getElementById('labs')) {
    mount(LabelValueParagraph, {
      target: document.getElementById('labs'),
      props: {
        store: labsDerived
      }
    })
  }

  if(document.getElementById('total-industry-funding')) {
    mount(LabelValueParagraph, {
      target: document.getElementById('total-industry-funding'),
      props: {
        store: restotalindustryfundingDerived
      }
    })
  }

  if(document.getElementById('cores')) {
    mount(LabelValueParagraph, {
      target: document.getElementById('cores'),
      props: {
        store: coresDerived,
      }
    })
  }
}